var cardExpandableBoxStyles = {
  root: function root() {
    return {
      display: 'flex'
    };
  }
};
export default cardExpandableBoxStyles;
//# sourceMappingURL=cardExpandableBoxStyles.js.map
